






























import { Component, Prop, Provide, Vue, Watch, Mixins } from 'vue-property-decorator'
import { ExtraData, SendMessageData, TaskInstance } from '../types/task'
import HandleButtons from './taskHandle/HandleButtons.vue'
import JzdxRejectInfo from './taskHandle/JzdxRejectInfo.vue'
import YqxyyRejectInfo from './taskHandle/YqxyyRejectInfo.vue'
import ImageReviewRejectInfo from './taskHandle/ImageReviewRejectInfo.vue'
import PassInfo from './taskHandle/PassInfo.vue'
import YqxyyPassInfo from './taskHandle/YqxyyPassInfo.vue'
import RejectInfo from './taskHandle/RejectInfo.vue'
import UpgradeInfo from './taskHandle/UpgradeInfo.vue'
import TaskInfo from './TaskInfo.vue'
import SongguoPassInfo from './taskHandle/SongguoPassInfo.vue'
import SongguoRejectInfo from './taskHandle/SongguoRejectInfo.vue'
import AdPassInfo from './taskHandle/AdPassInfo.vue'
import AdRejectInfo from './taskHandle/AdRejectInfo.vue'
import WeMediaPassInfo from './taskHandle/WeMediaPassInfo.vue'
import WeMediaRejectInfo from './taskHandle/WeMediaRejectInfo.vue'
import QkRejectInfo from './taskHandle/QkRejectInfo.vue'
import { Record } from './taskHandle/Record'

@Component({
  components: { TaskInfo }
})
export default class ViewTask extends Mixins(Record) {
  mounted() {
    this.layout
  }
  public get handleCmp() {
    if (this.layout == 'pass') {
      return PassInfo
    } else if (this.layout == 'reject') {
      return RejectInfo
    } else if (this.layout == 'jzdx-reject') {
      return JzdxRejectInfo
    } else if (this.layout == 'yqxyy-pass') {
      return YqxyyPassInfo
    } else if (this.layout == 'yqxyy-reject') {
      return YqxyyRejectInfo
    } else if (this.layout == 'songguo-pass') {
      return SongguoPassInfo
    } else if (this.layout == 'songguo-reject') {
      return SongguoRejectInfo
    } else if (this.layout == 'imageReivew-reject') {
      return ImageReviewRejectInfo
    } else if (this.layout == 'ad-pass') {
      return AdPassInfo
    } else if (this.layout == 'ad-reject') {
      return AdRejectInfo
    } else if (this.layout == 'we-media-pass') {
      return WeMediaPassInfo
    } else if (this.layout == 'we-media-reject') {
      return WeMediaRejectInfo
    } else if (this.layout == 'upgrade') {
      return UpgradeInfo
    } else if (this.layout == 'qk-reject') {
      return QkRejectInfo
    } else {
      return HandleButtons
    }
  }
  @Prop() public data!: TaskInstance
  @Prop() public sendMessageData!: SendMessageData
  @Prop() public extraData!: ExtraData
  @Prop() public visible!: boolean

  private showAuditHistory = false

  private layout = 'buttons'

  public showModal() {
    this.$emit('change', true)
  }
  public handleOk(e) {
    this.$emit('change', false)
  }

  @Watch('data')
  private onDataChange() {
    this.layout = ''
  }

  private setLayout(layout: string, reload: boolean) {
    if (layout == 'close') {
      this.$emit('change', false)
    } else {
      if (layout == 'return') {
        this.$emit('reset')
      }
      this.layout = layout
      // 记录'审核员'选择处理结果时间（通过/驳回/升级按钮时间）
      this.getFinishTime({
        instance_id: this.data.id,
        task_id: this.data.current_task.id,
        step: 'deal_result'
      })
    }
    if (reload) {
      this.$emit('reload')
    }
  }
}
